
$(function () {
    messagerieAfterAjax();
    $(document).on("click", ".messagerieShow", function (e) {
        e.preventDefault();
        let element = $(this);
        messagerieShow(element);
    });

    $(document).on("click", ".messagerieSend", function (e) {
        e.preventDefault();
        let element = $($(this).data('id'));

        $('#globalLoader').show();
        $.ajax({
            url: $(this).data('href'),
            type: 'POST',
            headers: {
               'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {'message' : $('#messagerieMessage').val()},
            success: function (response) {
                messagerieShow(element);
                messagerieAfterAjax();
                //$('#globalLoader').hide();
            },
            error: function (response) {
                $('#globalLoader').hide();
                messagerieAfterAjax();
            },
        });
    });

    
});

function messagerieAfterAjax() {
    autosize($('#messagerieMessage'));
    $('.back_responsive_btn').on('click', function() {
        $('.messagerie').removeClass('opened');
    });
}

function messagerieShow(element) {

    $('#globalLoader').show();
    $.ajax({
        url: element.attr('href'),
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: element.serializeArray(),
        success: function (response) {
            $('#globalLoader').hide();
            $('.discussion_list .current').each(function( index ) {
                $(this).removeClass('current');
            });
            element.addClass('current');
            $('.messagerie').addClass('opened');
            $('#messagerieDiscussionContent').html(response.html);
            element.find('.messagerieNbNonLus').hide();
            const messageries = document.querySelectorAll('.messagerie .discussion_body');
            const scrollToBottom = (node) => {
                node.scrollTop = node.scrollHeight;
            }
            messageries.forEach(function (element) {
                scrollToBottom(element);
            });
            window.history.replaceState(null, null, element.attr('href'));
            messagerieAfterAjax();
        },
        error: function (response) {
            $('#globalLoader').hide();
            messagerieAfterAjax();
        },
    });

}
